<template>
  <el-container>
    <publicHeader :currencyShow="currencyShow" @hotelLanguage="hotelLanguage"></publicHeader>
    <el-main>
    <!-- :style="{ height: `${elementHeight}px` }" -->
      <div class="main" ref="element">
        <div style="color:#4F4C4C;">
          <div class="StatusDiv">
            <div style="display:block;">
              <img src="/static/img/order/payDisabled.png" style="width:80px; height:80px;">
            </div>
            <div class="fail-reserve-text-two">
              {{ $t('payDisabled') }}
            </div>
            <div class="contact-info">
              <div>{{ $t('payContact') }}</div>
              <div style=" margin-top: 10px;" v-if="contactInfo.phone_internal !== '' || contactInfo.phone_external !== ''">
                <div style="display: inline-block;vertical-align: top;">{{ $t('phoneNumberTwo') }}</div>
                <div style="display: inline-block;">
                  <span style="display: block;" v-if="contactInfo.phone_internal !== ''">
                    <span v-for="(value, key) in contactInfo.phone_internal" :key="key">
                      <a v-if="key !== 0">/</a>{{ value }}
                    </span>（{{$t('internationalCall')}}）
                  </span>
                  <span style="display: block;" v-if="contactInfo.phone_external !== ''">
                    <span v-for="(value, key) in contactInfo.phone_external" :key="key">
                      <a v-if="key !== 0">/</a>{{ value }}
                    </span>（{{$t('domesticCall')}}）
                  </span>
                </div>
              </div>
              <div style=" margin-top: 10px;" v-if="contactInfo.customer_email !== ''">
                <div style="display: inline-block;vertical-align: top;">{{ $t('contactEmail') }}</div>
                <div style="display: inline-block;">
                  <span style="display: block;" v-for="(value, key) in contactInfo.customer_email" :key="key">
                    {{ value }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <publicFooter></publicFooter>
  </el-container>
  </template>
<script>
import { getContactInfo } from '@/request/question.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
export default {
  name: 'PayDisabled',
  components: {
    publicFooter,
    publicHeader
  },
  data () {
    return {
      currencyShow: false, // 币种是否显示
      elementHeight: document.body.clientHeight - 350,
      language: this.common.languageSet(this),
      contactInfo: {},
      customerEmail: {0: ''},
      source: 'roompai'
    }
  },
  watch: {
    language: function (newCur, oldCur) {
      // this.getContactInfo()
    }
  },
  mounted () {
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    this.getContactInfo()
  },
  methods: {
    hotelLanguage (language) {
      this.language = language
    },
    getContactInfo () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'source': this.source,
        'time': time,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getContactInfo(data).then(res => {
        if (res.flag === '200') {
          this.contactInfo = res.data
          this.customerEmail = this.contactInfo.customer_email
        }
      })
    }
  }
}
</script>
  <style scoped>
  .el-main {background-color: rgba(255, 255, 240, 1);color: #4F4C4C;text-align: center;line-height:35px;}
  .main {width:1100px;margin: 0 auto;height:100vh;display: flex;justify-content: center;align-items: center;}
  .fail-reserve-text-two{font-weight: 650; font-size: 22px; color: #4F4C4C;}
  .contact-info{font-size: 14px;text-align: left; line-height: 20px; margin-top: 25px;}
  @media screen and (max-width: 1000px) {
  .main {width:95%;}
  }
  </style>



// WEBPACK FOOTER //
// src/components/order/PayDisabled.vue